<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isPurchaseManager()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Purchase Manager |  Home</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<br>
<!-- main row for all icons  -->
<div class="col-md-11">
  <br>
<h5>Statistics</h5>
<br>
<div class="row" align="center">

 <div class="col-lg-12 col-12">
   <div class="row">
     <h5>Today</h5>
   </div>
 	<div class="row">
            <!-- small box -->
            <div class="col-lg-4 col-6">
              <div class="small-box bg-danger">
              <div class="inner">
                <h3>{{dailyreq}}</h3>

                <p>Daily Requests</p>
              </div>
              <div class="icon">
                <i class="ion ion-stats-bars"></i>
              </div>
              <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
            </div>
            </div>
            <div class="col-lg-4 col-6">
              <div class="small-box bg-danger">
              <div class="inner">
                <h3>{{dailycomp}}</h3>

                <p>Daily Completed</p>
              </div>
              <div class="icon">
                <i class="ion ion-stats-bars"></i>
              </div>
              <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
            </div>
            </div>
            <div class="col-lg-4 col-6">
              <div class="small-box bg-danger">
              <div class="inner">
                <h3>{{dailydeclined}}</h3>

                <p>Daily Declined</p>
              </div>
              <div class="icon">
                <i class="ion ion-stats-bars"></i>
              </div>
              <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
            </div>
            </div>
            <div class="col-lg-4 col-6">
              <div class="small-box bg-danger">
              <div class="inner">
                <h3>{{dailypending}}</h3>

                <p>Daily Pending</p>
              </div>
              <div class="icon">
                <i class="ion ion-stats-bars"></i>
              </div>
              <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
            </div>
            </div>
            </div>
            <br>
            <br>
            <div class="row">
              <h5>This month</h5>
            </div>
            <div class="row">
               <div class="col-lg-4 col-6">
              <div class="small-box bg-danger">
              <div class="inner">
                <h3>{{monthlyreq}}</h3>

                <p>Monthly Requests</p>
              </div>
              <div class="icon">
                <i class="ion ion-stats-bars"></i>
              </div>
              <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
            </div>
            </div>
            <div class="col-lg-4 col-6">
              <div class="small-box bg-danger">
              <div class="inner">
                <h3>{{monthlycomp}}</h3>

                <p>Monthly Completed</p>
              </div>
              <div class="icon">
                <i class="ion ion-stats-bars"></i>
              </div>
              <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
            </div>
            </div>
            <div class="col-lg-4 col-6">
              <div class="small-box bg-danger">
              <div class="inner">
                <h3>{{monthlydeclined}}</h3>

                <p>Monthly Declined</p>
              </div>
              <div class="icon">
                <i class="ion ion-stats-bars"></i>
              </div>
              <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
            </div>
            </div>
            <div class="col-lg-4 col-6">
              <div class="small-box bg-danger">
              <div class="inner">
                <h3>{{monthlypending}}</h3>

                <p>Monthly Pending</p>
              </div>
              <div class="icon">
                <i class="ion ion-stats-bars"></i>
              </div>
              <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
            </div>
            </div>
            </div>
          </div>
</div>

</div>


<!-- content here -->


<!-- row end -->
    </section>
    <!-- /.content -->


    
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isPurchaseManager()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        created(){
        	this.getCounts();
        },
        
        data(){
        	return {
        		dailyreq: '-',
        		monthlyreq: '-',
        		dailycomp: '-',
        		monthlycomp: '-',
        		dailydeclined: '-',
        		monthlydeclined: '-',
        		dailypending: '-',
        		monthlypending: '-'
        	}
        },
        
        methods: {
        	getCounts(){
        		axios.post("/api/getPMCount")
        		.then(response => {
        			this.dailyreq = response.data.dailyreq;
        			this.monthlyreq = response.data.monthlyreq;
        			this.dailycomp = response.data.dailycomp;
        			this.monthlycomp = response.data.monthlycomp;
        			this.dailydeclined = response.data.dailydeclined;
        			this.monthlydeclined = response.data.monthlydeclined;
        			this.dailypending = response.data.dailypending;
        			this.monthlypending = response.data.monthlypending;
        		})
        	}
        }
    }
</script>
